import axios from 'axios';

const instance = axios.create({
     //baseURL:'https://feedsrv.geoactivity.com/api/'
     baseURL:'https://garigsapi.azure-api.net/'
     //baseURL:'https://localhost:44365/api/'
})

export default instance;